/**
 * A simple CSS-only spinner
 * @element mx-spinner
 * @example
 * <mx-spinner></mx-spinner>
 */
class Spinner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const shadow = this.attachShadow({ mode: "open" });
    const style = document.createElement("style");
    const el = document.createElement("div");
    el.classList.add("spinner");

    style.textContent = `
      @keyframes spinner {
        to {transform: rotate(360deg);}
      }

      :host {
        --spinner-color: currentColor;
        --spinner-dimensions: 12px;
        display: inline-block;
      }

      .spinner {
        width: var(--spinner-dimensions);
        height: var(--spinner-dimensions);
        position: relative;
      }
       
      .spinner:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: var(--spinner-dimensions);
        height: var(--spinner-dimensions);
        margin-top: -5px;
        border-radius: 50%;
        border-top: 2px solid var(--spinner-color);
        border-right: 2px solid transparent;
        animation: spinner .6s linear infinite;
      }
  `;
    shadow.appendChild(style);
    shadow.appendChild(el);
  }
}

customElements.define("mx-spinner", Spinner);
